import React from 'react';

export const UploadIcon = props => (
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M15 5H4C2.35 5 1 6.35 1 8v18c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19 6h10M24 1v10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M22 24H4l4.5-5.6 3.045 3.794L16 17l6 7zM10 12c0-1.10666667-.89333333-2-2-2s-2 .89333333-2 2c0 1.1066667.89333333 2 2 2s2-.8933333 2-2z"
        fill="currentColor"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/UploadIcon.js